import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, FormHelperText, Grid, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import CustomAutocomplete from "../../../components/Form/CustomAutocomplete";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../../components/Form/DatePicker";
import InventoryVehicleDetailsSummaryModal from "../modal/InventoryVehicleDetailsSummary";
import SelectedVehicleSummary from "../modal/SelectedVehicleSummary";

const InventoryVehicleInfo = ({ formObj, handleFormChange, invType, isDirectSeller, license_categories, isSingPass, defaultMyinfo, makeList, modelList, bodyList, error,
    windowWidth, setRequestNewOpen, transmissionList, preSelectBodyType, setPreSelectBodyType, defaultColorList, is_manually_fill, inventoryStockStatuses }) => {
    const [detailOpen, setDetailOpen] = React.useState(false);
    const stockStatusOptions = (Array.isArray(inventoryStockStatuses)
        ? inventoryStockStatuses
        : Array.isArray(inventoryStockStatuses?.data)
            ? inventoryStockStatuses.data
            : inventoryStockStatuses?.data?.inventoryStockStatuses
            || inventoryStockStatuses?.data?.erp_stock_statuses
            || inventoryStockStatuses?.inventoryStockStatuses
            || []).filter((status) => {
                const value = String(status?.value ?? status?.label ?? '').toLowerCase();
                const label = String(status?.label ?? status?.value ?? '').toLowerCase();
                return !['unpublished', 'void'].includes(value) && !['unpublished', 'void'].includes(label);
            });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleSelectBodyType = (item) => {
        if (preSelectBodyType?.includes(item?.id || item?.bike_type_id)) {
            return
        } else {
            let updatedBodyType = Array.isArray(formObj?.body_type) ? [...formObj?.body_type] : [];
            if (updatedBodyType.includes(item?.id || item?.bike_type_id)) {
                updatedBodyType = updatedBodyType.filter((type) => type !== (item?.id || item?.bike_type_id));
            } else {
                updatedBodyType.push(item?.id || item?.bike_type_id);
            }
            handleFormChange('body_type', updatedBodyType);
        }


    }

    useEffect(() => {
        // if (isDirectSeller && formObj?.is_manually_fill !== true && formObj?.bike_model_id) {
        const body_list = filterModelList?.find((item => item?.id == formObj?.bike_model_id)) || [];
        const body_list_ids = body_list?.bike_types?.map((x) => x.bike_type_id) || [];
        const selectedModel = modelList.find((model) => model.id === formObj?.bike_model_id);
        const hasSelectedBodyTypes = Array.isArray(formObj?.body_type) && formObj.body_type.length > 0;
        if (selectedModel && !hasSelectedBodyTypes) {
            // Set license_category_id from the selected model
            handleFormChange('license_category_id', selectedModel.license_category || "");
            handleFormChange('engine_cap', selectedModel.engine_cc || "");
            handleFormChange('body_type', body_list_ids || []);
            setPreSelectBodyType(body_list_ids || []);
        }
        // }
    }, [formObj?.bike_model_id])


    const filterModelList = formObj?.bike_make_id ? makeList.find((model) => model.id == formObj?.bike_make_id)?.models : modelList;
    const filterColorList = filterModelList?.find((item => item?.id == formObj?.bike_model_id))?.colours || [];
    const filterBodyList = bodyList;
    const bodyType = Array.isArray(formObj?.body_type) ? formObj?.body_type?.map((type) => filterBodyList.find((item) => (item.bike_type_id || item?.id) == type)?.name) : [];
    return (
        <React.Fragment>
            <SelectedVehicleSummary formObj={formObj} setDetailOpen={setDetailOpen} />
            {invType === "used" &&
                <Box mt={3}>
                    <div className="text-semibold">Owner Details</div>
                    <Grid container spacing={2}>
                        <Grid item sm={12} xs={12}>
                            <CustomTextField
                                title={'Owner Name'}
                                values={formObj?.owner_name || ''}
                                onChange={(e) => handleFormChange('owner_name', e)}
                                error={error?.owner_name}
                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Email Address'}
                                isOptional={true}
                                values={formObj?.email || ''}
                                onChange={(e) => handleFormChange('email', e)}
                                error={error?.email}

                            />
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                values={formObj?.phone}
                                onChange={(e) => handleFormChange('phone', e)}
                                title='Phone Number'
                                placeholder='Phone Number'
                                type={'phone'}
                                // isOptional={true}
                                InputProps={{
                                    startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                                }}
                                error={error?.owner_phone}
                            />
                        </Grid>

                    </Grid>
                </Box>}
            <Box mt={3}>
                <div className="text-semibold">Make & Model</div>
                <Grid container spacing={2}>
                    {isSingPass &&
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Make (Myinfo)'}
                                    placeholder={'Make'}
                                    values={defaultMyinfo?.make || ''}
                                    onChange={(e) => handleFormChange('myinfo_make', e)}
                                    error={error?.myinfo_make}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Model (Myinfo)'}
                                    placeholder={'Model'}
                                    values={defaultMyinfo?.model || ''}
                                    onChange={(e) => handleFormChange('myinfo_model', e)}
                                    error={error?.myinfo_model}
                                    disabled={true}

                                />
                            </Grid>
                        </>}
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomAutocomplete
                            title={'Make'}
                            placeholder={'Make'}
                            values={formObj?.bike_make_id || null}
                            onChange={(e, value) => {
                                handleFormChange('bike_make_id', value?.id);
                                handleFormChange('body_type', []);
                                setPreSelectBodyType([]);
                            }}
                            freeSolo={false}
                            data={makeList}
                            disabled={isSingPass}
                            labelName="name"
                            valueName="id"
                            error={error?.bike_make_id}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomAutocomplete
                            title={'Model'}
                            placeholder={'Model'}
                            values={formObj?.bike_model_id || null}
                            onChange={(e, value) => {
                                handleFormChange('bike_model_id', value?.id);
                            }}
                            data={filterModelList}
                            labelName="name"
                            valueName="id"
                            error={error?.bike_model_id}
                        />
                    </Grid>

                    {invType !== "new" &&
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Registration Number'}
                                values={formObj?.reg_no || ''}
                                disabled={isSingPass}
                                isOptional={true}
                                onChange={(e) => handleFormChange('reg_no', e)}
                                error={error?.registration_number}
                            />
                        </Grid>}

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Year of Manufacture'}
                            placeholder={'Year of Manufacture'}
                            isOptional={true}
                            disabled={isSingPass}
                            values={formObj?.manu_year || ''}
                            onChange={(e) => handleFormChange('manu_year', e)}
                            error={error?.manu_year}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomSelect
                            title={'License Category'}
                            placeholder={'License Category'}
                            values={formObj?.license_category_id || ''}
                            onChange={(e) => handleFormChange('license_category_id', e)}
                            data={license_categories}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.license_category_id}
                        />
                    </Grid>

                </Grid>
            </Box>
            {invType !== "used" &&
                <Box mt={4}>
                    <div className="text-semibold">Primary Colour <span className="optional-label me-2">Optional</span></div>
                    <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        {filterColorList?.length > 0 ? filterColorList.map((color, index) => (
                            <div className={formObj?.bike_model_colour_id && (formObj?.bike_model_colour_id === color?.id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormChange('colour_text', null); handleFormChange('bike_model_colour_id', formObj?.bike_model_colour_id === color?.id ? null : color?.id); }}>
                                {color?.name}
                            </div>
                        )) || <div className="subheader-2">No Data Available</div> : defaultColorList.map((color, index) => (
                            <div className={formObj?.colour_text && (formObj?.colour_text === color?.value) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormChange('colour_text', formObj?.colour_text === color?.value ? null : color?.value); handleFormChange('bike_model_colour_id', null); }}>
                                {color?.label}
                            </div>
                        )) || <div className="subheader-2">No Data Available</div>}
                    </Stack>
                </Box>}
            <Box mt={4}>
                <div className="text-semibold">Body Type</div>
                <div className="subheader-2">Select one or more</div>
                <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                    {filterBodyList?.length > 0 ? filterBodyList?.map((item, index) => (
                        <div className={preSelectBodyType?.length > 0 && preSelectBodyType?.includes(item?.id || item?.bike_type_id) ? "default-selected" : formObj?.body_type?.includes(item?.id || item?.bike_type_id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleSelectBodyType(item)}>
                            {item?.name}
                        </div>
                    )) : <div className="subheader-2">No Data Available</div>}
                </Stack>
                {error?.body_types && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.body_types || ""}</FormHelperText>}
            </Box>
            <Box mt={4}>
                <div className="text-semibold">Specification</div>
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Engine Capacity (CC)'}
                            placeholder={'Engine Capacity (CC)'}
                            values={formObj?.engine_cap}
                            type={'number'}
                            onChange={(e) => handleFormChange('engine_cap', e)}
                            error={error?.engine_cc}
                        />
                    </Grid>
                    {
                        invType === "used" &&
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomizedDatePicker
                                    title={"Registration Date"}
                                    values={(formObj?.reg_date || formObj?.first_reg_date) && new Date(formObj?.reg_date || formObj?.first_reg_date)}
                                    placeholder={"dd/mm/yyyy"}
                                    disabled={isSingPass}
                                    setFormValues={(e) => handleFormChange('reg_date', e)}
                                    error={error?.reg_date || error?.registration_date}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomizedDatePicker
                                    title={"COE Expiry Date"}
                                    values={formObj?.coe_expiry && new Date(formObj?.coe_expiry)}
                                    placeholder={"dd/mm/yyyy"}
                                    disabled={isSingPass}
                                    setFormValues={(e) => handleFormChange('coe_expiry', e)}
                                    error={error?.coe_expiry}
                                />
                            </Grid>
                        </>
                    }
                    {invType !== "new" &&
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={<>Mileage (KM)</>}
                                    placeholder={'Mileage (KM)'}
                                    type={'number'}
                                    isOptional={true}
                                    values={formObj?.mileage ?? ""}
                                    onChange={(e) => handleFormChange('mileage', e)}
                                    error={error?.mileage_in_km}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'No. of Owner(s)'}
                                    placeholder={'No. of Owner(s)'}
                                    type={'number'}
                                    disabled={isSingPass}
                                    values={formObj?.no_of_owner ?? ""}
                                    onChange={(e) => handleFormChange('no_of_owner', e)}
                                    error={error?.no_of_previous_owners}
                                />
                            </Grid>

                        </>
                    }
                </Grid>
            </Box>

            {/* <Box mt={4}>
                <div className="text-semibold">Stock Status</div>
                <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                    {stockStatusOptions.map((status) => (
                        <div key={status.value} className={formObj?.stock_status === status.value ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleFormChange('stock_status', formObj?.stock_status === status.value ? null : status.value)}>
                            {status.label}
                        </div>
                    ))}
                </Stack>
                {error?.stock_status && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.stock_status || ""}</FormHelperText>}
            </Box> */}

            <div className="mt-4">
                <div className="text-semibold">Internal Remarks <span className="optional-label me-2">Optional</span></div>
                <CustomTextField
                    multiline={true}
                    rows={5}
                    values={formObj?.internal_remarks ?? ""}
                    onChange={(e) => handleFormChange('internal_remarks', e)}
                    error={error?.internal_remarks}
                />
            </div>

            <InventoryVehicleDetailsSummaryModal
                open={detailOpen}
                invType={invType}
                close={() => setDetailOpen(false)}
                selectedVehicle={formObj}
                windowWidth={windowWidth}
                bodyList={bodyList}
                isSingPass={isSingPass}

            />
        </React.Fragment >
    )
}

function mapStateToProps({ General, Layout }) {
    return {
        windowWidth: Layout.currentWidth,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        license_categories: General.license_categories,
        transmissionList: General.transmissions,
        defaultColorList: General.default_colours,
    };
}


export default connect(mapStateToProps)(InventoryVehicleInfo);
